import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import type { RealtimeChannel } from '@supabase/supabase-js';

export const useSprintRealtime = (
  sprintId: string,
  onDecisionUpdate?: (payload: any) => void,
  onContributionUpdate?: (payload: any) => void,
  onInformContentUpdate?: (payload: any) => void
) => {
  useEffect(() => {
    if (!sprintId) return;

    const channels: RealtimeChannel[] = [];

    // Subscribe to decision updates
    if (onDecisionUpdate) {
      const decisionChannel = supabase
        .channel(`sprint-decisions-${sprintId}`)
        .on(
          'postgres_changes',
          {
            event: '*',
            schema: 'public',
            table: 'sprint_decisions',
            filter: `sprint_id=eq.${sprintId}`
          },
          onDecisionUpdate
        )
        .subscribe();
      
      channels.push(decisionChannel);
    }

    // Subscribe to contribution updates
    if (onContributionUpdate) {
      const contributionChannel = supabase
        .channel(`sprint-contributions-${sprintId}`)
        .on(
          'postgres_changes',
          {
            event: '*',
            schema: 'public',
            table: 'sprint_contributions',
            filter: `sprint_id=eq.${sprintId}`
          },
          onContributionUpdate
        )
        .subscribe();
      
      channels.push(contributionChannel);
    }

    // Subscribe to inform content updates (for real-time collaboration)
    if (onInformContentUpdate) {
      const informContentChannel = supabase
        .channel(`sprint-inform-content-${sprintId}`)
        .on(
          'postgres_changes',
          {
            event: '*',
            schema: 'public',
            table: 'sprint_inform_content',
            filter: `sprint_id=eq.${sprintId}`
          },
          onInformContentUpdate
        )
        .subscribe();
      
      channels.push(informContentChannel);
    }

    return () => {
      channels.forEach(channel => {
        supabase.removeChannel(channel);
      });
    };
  }, [sprintId, onDecisionUpdate, onContributionUpdate, onInformContentUpdate]);
};